// Tabela de conversão de letras para números
const tabelaNumerologia: { [key: string]: number } = {
  'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5, 'f': 8, 'g': 3, 'h': 5, 'i': 1, 'j': 1,
  'k': 2, 'l': 3, 'm': 4, 'n': 5, 'o': 7, 'p': 8, 'q': 1, 'r': 2, 's': 3,
  't': 4, 'u': 6, 'v': 6, 'w': 6, 'x': 6, 'y': 1, 'z': 7, 'á': 3, 'é': 7,
  'í': 3, 'ó': 9, 'ú': 8, 'ã': 4, 'õ': 1, 'â': 8, 'ê': 3, 'î': 8, 'ô': 5,
  'û': 4, 'à': 2, 'è': 1, 'ì': 2, 'ò': 5, 'ù': 3, 'ç': 6, 'ä': 2, 'ë': 1, 
  'ï': 2, 'ö': 5, 'ü': 3, "'": 2
};

// Função auxiliar para somar dígitos até reduzir a um único algarismo
function reduzirNumero(num: number): number {
  while (num > 9) {
    num = String(num).split('').reduce((acc, val) => acc + parseInt(val), 0);
  }
  return num;
}

// Função removida - usando highlightRepeatedSequencesSafe do sanitize.ts

// Interface para retorno das funções de cálculo
interface PiramideResult {
  triangulo_invertido: string;
  base_triangulo_invertido: number;
}

// Função auxiliar para processar nome com apóstrofos
function processarNomeComApostrofo(nome: string, valorBase: number = 0): number[] {
  const nomeProcessado = nome.toLowerCase().replace(/\s+/g, '');
  const valores: number[] = [];
  
  for (let i = 0; i < nomeProcessado.length; i++) {
    const char = nomeProcessado[i];
    
    if (char === "'") {
      // Para apóstrofo, usar valor da letra anterior + valor base do apóstrofo (2)
      if (i > 0) {
        const letraAnterior = nomeProcessado[i - 1];
        const valorLetraAnterior = tabelaNumerologia[letraAnterior] || 0;
        const valorApostrofo = reduzirNumero(valorLetraAnterior + 2 + valorBase);
        valores.push(valorApostrofo);
      } else {
        // Se apóstrofo está no início, usar apenas valor base
        valores.push(reduzirNumero(2 + valorBase));
      }
    } else {
      const valorLetra = tabelaNumerologia[char] || 0;
      if (valorLetra !== 0) {
        valores.push(reduzirNumero(valorLetra + valorBase));
      }
    }
  }
  
  return valores;
}

// Função auxiliar para calcular pirâmide base
function calcularPiramideBase(valoresIniciais: number[], nome: string): PiramideResult {
  if (valoresIniciais.length === 0) {
    return { triangulo_invertido: '', base_triangulo_invertido: 0 };
  }

  // Criar o triângulo somando pares sucessivos
  let triangulo: number[][] = [valoresIniciais];
  
  while (triangulo[triangulo.length - 1].length > 1) {
    const novaLinha: number[] = [];
    const ultimaLinha = triangulo[triangulo.length - 1];

    for (let i = 0; i < ultimaLinha.length - 1; i++) {
      let soma = ultimaLinha[i] + ultimaLinha[i + 1];
      
      // Se estamos na última linha com dois dígitos e ambos são 1 ou 2, não reduzimos
      if (ultimaLinha.length === 2 && 
          (ultimaLinha[0] === ultimaLinha[1]) && 
          (ultimaLinha[0] === 1 || ultimaLinha[0] === 2)) {
        novaLinha.push(soma);
      } else {
        novaLinha.push(reduzirNumero(soma));
      }
    }
    triangulo.push(novaLinha);
  }

  // Calcular o comprimento máximo (primeira linha com nome)
  const nomeCaracteres = nome.replace(/\s+/g, '').toUpperCase().split('');
  const comprimentoMaximo = nomeCaracteres.length * 2 - 1; // Conta espaços entre caracteres
  
  // Criar as linhas da pirâmide
  const linhas: string[] = [];
  
  // Primeira linha - nome
  const nomeFormatado = nomeCaracteres.join('&nbsp;');
  const espacosNome = Math.floor((comprimentoMaximo - nomeCaracteres.length * 2 + 1) / 2);
  linhas.push('&nbsp;'.repeat(Math.max(0, espacosNome)) + nomeFormatado);
  
  // Segunda linha - números iniciais
  const numerosFormatados = valoresIniciais.join('&nbsp;');
  const espacosNumeros = Math.floor((comprimentoMaximo - valoresIniciais.length * 2 + 1) / 2);
  linhas.push('&nbsp;'.repeat(Math.max(0, espacosNumeros)) + numerosFormatados);
  
  // Linhas subsequentes do triângulo
  for (let i = 1; i < triangulo.length; i++) {
    const linha = triangulo[i].join('&nbsp;');
    const espacosLinha = Math.floor((comprimentoMaximo - triangulo[i].length * 2 + 1) / 2);
    linhas.push('&nbsp;'.repeat(Math.max(0, espacosLinha)) + linha);
  }

  const trianguloInvertidoString = linhas.join('<br>');
  const numeroFinal = triangulo[triangulo.length - 1][0];

  return { 
    triangulo_invertido: trianguloInvertidoString, 
    base_triangulo_invertido: numeroFinal 
  };
}

// Pirâmide da Vida - apenas o nome
export function calcularPiramideVida(nome: string): PiramideResult {
  if (!nome) {
    return { triangulo_invertido: '', base_triangulo_invertido: 0 };
  }

  const valoresNome = processarNomeComApostrofo(nome, 0);
  return calcularPiramideBase(valoresNome, nome);
}

// Função auxiliar para calcular o número de expressão
function calcularNumeroExpressao(nome: string): number {
  const nomeProcessado = nome.replace(/\s+/g, '').toLowerCase();
  const somaTotal = nomeProcessado.split('').reduce((acc, char) => {
    return acc + (tabelaNumerologia[char] || 0);
  }, 0);
  return reduzirNumero(somaTotal);
}

// Pirâmide Pessoal - nome + dia de nascimento reduzido
export function calcularPiramidePessoal(nome: string, dia: number): PiramideResult {
  if (!nome || !dia) {
    return { triangulo_invertido: '', base_triangulo_invertido: 0 };
  }

  // Reduzir o dia de nascimento de 1 a 9
  const diaReduzido = reduzirNumero(dia);
  const valoresNome = processarNomeComApostrofo(nome, diaReduzido);

  return calcularPiramideBase(valoresNome, nome);
}

// Pirâmide Social - nome + mês reduzido
export function calcularPiramideSocial(nome: string, mes: number): PiramideResult {
  if (!nome || !mes) {
    return { triangulo_invertido: '', base_triangulo_invertido: 0 };
  }

  // Processar o mês: apenas reduzir se for 11 ou 12
  let mesProcessado: number;
  if (mes === 11) {
    mesProcessado = 2; // 1+1=2
  } else if (mes === 12) {
    mesProcessado = 3; // 1+2=3
  } else {
    mesProcessado = mes; // Meses 1-10 permanecem como estão
  }

  const valoresNome = processarNomeComApostrofo(nome, mesProcessado);
  return calcularPiramideBase(valoresNome, nome);
}

// Pirâmide do Destino - nome + dia + mês reduzidos
export function calcularPiramideDestino(nome: string, dia: number, mes: number): PiramideResult {
  if (!nome || !dia || !mes) {
    return { triangulo_invertido: '', base_triangulo_invertido: 0 };
  }

  const diaReduzido = reduzirNumero(dia);
  const mesReduzido = reduzirNumero(mes);
  const valorBase = reduzirNumero(diaReduzido + mesReduzido);

  const valoresNome = processarNomeComApostrofo(nome, valorBase);
  return calcularPiramideBase(valoresNome, nome);
}

// Função legada para compatibilidade
export function calcularPiramideInvertida(nome: string): PiramideResult {
  return calcularPiramideVida(nome);
}
